import React from "react";
import { SvgHandler } from "../svg-handler/svg-handler";
import searchIcon from "../../../assets/icons/search.svg";
import PropTypes from "prop-types";
import { SearchBox } from "./search-box";

function DrawForm({ children }) {
  return [
    <div key="1">
      <label className="qt-search__form-label" htmlFor="searchForm">
        {children}
      </label>
      <button className="search-icon">
        <SvgHandler xlinkHref={searchIcon} width="24" height="24" />
      </button>
    </div>
  ];
}

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchFormOpen: false,
      initialized: false
    };
  }

  componentDidMount() {
    this.setState({
      initialized: true
    });
  }

  toggleSearchForm = () => {
    this.setState({ isSearchFormOpen: !this.state.isSearchFormOpen });
  };

  render() {
    return (
      <div className="qt-search">
        <div className="qt-search__form-wrapper">
          <SearchBox
            className="qt-search__form"
            template={DrawForm}
            inputId="searchForm"
            inputRef={input => (this.input = input)}
            inputClassName="qt-search__form-input"
            formRef={searchForm => (this.searchForm = searchForm)}
            onSubmitHandler={() => this.setState({ isSearchFormOpen: false })}
            onEscape={() => this.setState({ isSearchFormOpen: false })}
            placeholder="Search"
            initValue={this.props.q}
          />
        </div>
      </div>
    );
  }
}
Search.propTypes = {
  q: PropTypes.string
};

export { Search };
